module.exports = __webpack_public_path__ + "img/hours_gellerwill11.a97490d.png";